export default __webpack_public_path__ + "static/banner3-e40b854cfd6598f06b7df200cdacc3bc.png";